import { useDispatch, useSelector } from "react-redux";
import { setOpenOtherMenu, TransitionSystem } from "../Reducer/ModalSlice";
import { useState } from "react";
import { ClearSelectedCity } from "../Reducer/CitySlice";
import { ClearSelectedMonth } from "../Reducer/MonthSlice";
import { FaSyncAlt } from "react-icons/fa"
import { roleId } from "../Components/Constants/app";
import { clearRevenueModule } from "../Reducer/RevenueModuleSlice";


function OtherMenu(){
    const OpenModal = useSelector(state => state.ModalSlice.OpenModal)

    const User = useSelector(state => state.UserSlice.User)

    const [CancelTouch, setCancelTouch] = useState(false)

    const dispatch = useDispatch()

    return(
        <div
        className="OtherMenuMainDiv"
        >
            <div
            className={OpenModal.OpenOtherMenu ? "MainMenuOptionsDiv" : "MainMenuOptionsDiv Close"}
            >
                {OpenModal.SelectedSystem && !OpenModal.OpenStaffManagment && !OpenModal.OpenRevenue && User.user.role.id !== roleId.cashier &&
                <button
                className="ButtonMainMenu Options"
                onClick={(async () => {
                await dispatch(TransitionSystem())
                dispatch(ClearSelectedCity())
                dispatch(ClearSelectedMonth())
                dispatch(clearRevenueModule())
                })}
                onTouchStart={() => {
                setCancelTouch(false)
                }}
                onTouchMove={() => {
                    setCancelTouch(true)
                }}
                onTouchCancel={() => {
                    setCancelTouch(true)
                }}
                onTouchEnd={(async (event) => {
                event.preventDefault()
                if(!CancelTouch)
                {
                    await dispatch(TransitionSystem())
                    dispatch(clearRevenueModule())
                    dispatch(ClearSelectedCity())
                    dispatch(ClearSelectedMonth())
                }
                })}
                >
                <div className="IconButtonMainMenuDiv"> <FaSyncAlt /> </div> Выбор модуля
                </button>
                }
            </div>

            <div
            className={OpenModal.OpenOtherMenu ? "BlackoutMainMenuOptionsDiv" : "BlackoutMainMenuOptionsDiv Close"}
            onClick={(() => {
                dispatch(setOpenOtherMenu(false))
            })}
            onTouchStart={() => {
                setCancelTouch(false)
            }}
            onTouchMove={() => {
                setCancelTouch(true)
            }}
            onTouchCancel={() => {
                setCancelTouch(true)
            }}
            onTouchEnd={((event) => {
                event.preventDefault()
                if(!CancelTouch)
                    dispatch(setOpenOtherMenu(false))
            })}
            />
        </div>
    )
}

export default OtherMenu;